import { AppScrollWrapperNew } from '../../../../widgets/AppScrollWrapper/AppScrollWrapper'
import { OrderLineItem } from './OrderLineItem'
import { IPlanMenuControlOrdersRequest } from 'core/api/dto/PlanMenuControlDto'
import { useSearchParams } from 'react-router-dom'

import { useGetPlanMenuCloseOrderQuery } from 'core/api/PlanMenuCloseApi'
interface IOrderLineListProps {
  pageParams: IPlanMenuControlOrdersRequest | null
  setIsShowPopup: () => void
}

export const OrderLineList = ({
  pageParams,
  setIsShowPopup,
}: IOrderLineListProps) => {
  const [searchParams] = useSearchParams()
  const currentOrderId = searchParams.get('order')
  const { data } = useGetPlanMenuCloseOrderQuery({
    id: Number(currentOrderId!),
  })

  return (
    <div className="history-block">
      <AppScrollWrapperNew theme="dropdown">
        {data &&
          data?.orderLines?.map((orderItem, index) => (
            <OrderLineItem
              key={index}
              orderItem={orderItem}
              setIsShowPopup={setIsShowPopup}
            />
          ))}
      </AppScrollWrapperNew>
    </div>
  )
}
